<template>
  <div class="page-rappresnentanti-detail">
    <rappresentanti-detail />
  </div>
</template>

<script>
import RappresentantiDetail from '@/components/ask/details/RappresentantiDetail.vue'


export default {
  name: 'ViewRappresentantiDetail',
  components: {
    RappresentantiDetail,
  },

  data() {
    return {
      pageName: 'RappresentantiDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
